export default "__VITE_ASSET__CUofeyqq__"